import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "compass",
  "use": "compass-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"compass\"><path d=\"M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm0-2C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm6 5.999l-5.621 2.986a3 3 0 0 0-3.336 3.287L6 18l5.724-3.042a2.99 2.99 0 0 0 2.432-.865 2.984 2.984 0 0 0 .859-2.473L18 5.999zm-5.97 7.22a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol